import { Skin, Sport } from '#src/__generated__/globalTypes.ts';
import { SetColors } from '#src/atoms/icons/SetColors.tsx';

import commonPacksLogoImage from './assets/colors-logo.svg';
import cardRevealSwipeIconImage from './assets/colors-series-icon.svg';
import footballComposeTeam from './assets/compose-team/FootballFieldBackground.webp';
import playFootballBackgroundImage from './assets/footballBackground.webp';
import packOpeningBackground from './assets/pack-opening-background.webp';
import replayDialogFootballBackground from './assets/replayDialog/football.webp';
import footballDesktopCountdownBackground from './assets/seasonCountdown/desktopFootballBackground.webp';
import setLogoImage from './assets/set-logo.svg';
import squadFootballBoard from './assets/squad/footballBoard.webp';
import playVoucherIcon from './assets/voucher.svg';
import welcomeBackDialogBackground from './assets/welcomeBackDialogBackground.webp';

type SetPlaySportAssets = {
  backgroundImage: string;
};

const DEFAULT_SET_PLAY_SPORT_ASSETS: SetPlaySportAssets = {
  backgroundImage: playFootballBackgroundImage,
};

const SET_PLAY_SPORT_ASSETS: Partial<Record<Sport, SetPlaySportAssets>> = {
  [Sport.FOOTBALL]: DEFAULT_SET_PLAY_SPORT_ASSETS,
};

export const SET_COLORS = {
  slug: 'colors',
  cardEditionSlugs: [
    'colors_standard_base',
    'colors_shiny_base',
    'colors_shiny_rising',
    'colors_holo_base',
    'colors_holo_chroma',
    'colors_full_art_base',
  ] as const,
  skins: [Skin.STANDARD, Skin.SHINY, Skin.HOLO, Skin.FULL_ART],
  colors: {
    main: 'var(--c-set-colors-surface-primary)',
    mainRGB: [0, 0, 0] satisfies [number, number, number],
    swipeEffectColor: '#000000',
  },
  background: {
    background: '',
    backgroundBlendMode: 'normal',
  },
  visual: {
    board: {
      mobileDecoration: null,
    },
    commonPacks: {
      logoImage: commonPacksLogoImage,
    },
    cardReveal: {
      swipeIconImage: cardRevealSwipeIconImage,
      background: {
        background: `
      url("${packOpeningBackground}") center / cover no-repeat
        `,
        backgroundBlendMode: 'normal',
      },
      videoSources: null,
    },
    seasonCountdown: null,
    backgroundDesktop: {
      [Sport.FOOTBALL]: {
        background: `url("${footballDesktopCountdownBackground}") center / cover no-repeat`,
      },
    },
    brand: {
      logoImage: setLogoImage,
      SetIcon: SetColors,
    },
    play: {
      getSportAssets: (sport: Sport) =>
        SET_PLAY_SPORT_ASSETS[sport] || DEFAULT_SET_PLAY_SPORT_ASSETS,
      voucherIcon: playVoucherIcon,
    },
    replayDialog: {
      background: {
        [Sport.FOOTBALL]: replayDialogFootballBackground,
        [Sport.NBA]: undefined,
        [Sport.BASEBALL]: undefined,
      },
    },
    welcomeBackDialog: {
      background: `url(${welcomeBackDialogBackground}) center / cover no-repeat`,
    },
    composeTeam: {
      [Sport.FOOTBALL]: footballComposeTeam,
      [Sport.NBA]: undefined,
      [Sport.BASEBALL]: undefined,
    },
    squad: {
      boardBackground: {
        [Sport.FOOTBALL]: squadFootballBoard,
        [Sport.NBA]: squadFootballBoard,
        [Sport.BASEBALL]: undefined,
      },
    },
  },
} as const;
